import { ReactElement, useMemo } from 'react';

import { isOfType } from '@hsp/utilities';

import { Select } from 'components/select';
import { AsyncSelect } from 'components/select/async';
import { Group, GroupHeading, Option, VirtualMenuList } from 'components/select/shared';
import { calculateLength } from 'components/select/virtual/utilities';
import { VirtualSelectProps, VirtualSelectPropsThreshold } from 'types/components/select/virtual';

function VirtualSelect<IsMulti extends boolean = false, Option = unknown>(props: VirtualSelectProps<IsMulti, Option>) {
  const { components, options } = props;
  const count = useMemo(() => calculateLength(options), [options]);
  let Component: ReactElement = (
    <Select
      {...props}
      captureMenuScroll={false}
      components={{ MenuList: VirtualMenuList }}
    />
  );

  if (isOfType<VirtualSelectPropsThreshold<IsMulti, Option>>(props, 'threshold')) {
    const { filterOptions, threshold } = props;

    if (count > threshold) {
      Component = (
        <AsyncSelect
          {...props}
          captureMenuScroll={false}
          components={{
            Group,
            GroupHeading,
            Option,
            ...components,
            MenuList: VirtualMenuList,
          }}
          loadOptions={filterOptions}
        />
      );
    }
  }

  return Component;
}

export default VirtualSelect;
